import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { ImageCropperModule } from "ngx-image-cropper";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import { AppSharedModule } from "../../shared/app-shared.module";
import { IDAdminRoutes } from "./IDAdmin-routes";
import { IDAdminComponent } from "./index";

import { IDDesignComponent } from "./iddesign/iddesign.component";

import { BatchUploadComponent } from "./batchupload/batchupload.component";

import { PhotoMaintComponent } from "./photomaint/photomaint.component";
import { PhotoEditComponent } from "./photomaint/photoedit/photoedit.component";

import { ImageMaintComponent } from "./imagemaint/imagemaint.component";
import { ImageEditComponent } from "./imagemaint/imageedit/imageedit.component";
import { ImageAssociationComponent } from "./imagemaint/imageassociation/imageassociation.component";
import { ImageCopyComponent } from "./imagemaint/imagecopy/imagecopy.component";
import { ImageRenameComponent } from "./imagemaint/imagerename/imagerename.component";
import { ImageSetDistrictComponent } from "./imagemaint/imagesetdistrict/imagesetdistrict.component";

import { IDPrintComponent } from "./idprint/idprint.component";
import { SetPrinterComponent } from "./idprint/setprinter/setprinter.component";
import { SetCardComponent } from "./idprint/setcard/setcard.component";
import { SetFeeComponent } from "./idprint/setfee/setfee.component";
import { PrintComponent } from "./idprint/print/print.component";

import { PrinterMaintComponent } from "./printermaint/printermaint.component";

import { PhotoExportComponent } from "./photoexport/photoexport.component";

import { ClickOnceDeployComponent } from "./clickoncedeploy/clickoncedeploy.component";
import { IDPrintLockoutComponent } from "./idprintlockout/idprintlockout.component";

import { PersonSelectorModule } from "../personselector/personselector.module";

import { DataService_iddesign } from "./iddesign/shared/data.service";
import { DataService_batchupload } from "./batchupload/shared/data.service";
import { DataService_photomaint } from "./photomaint/shared/data.service";
import { DataService_imagemaint } from "./imagemaint/shared/data.service";
import { DataService_idprint } from "./idprint/shared/data.service";
import { DataService_printermaint } from "./printermaint/shared/data.service";
import { DataService_photoexport } from "./photoexport/shared/data.service";
import { DataService_clickoncedeploy } from "./clickoncedeploy/shared/data.service";
import { DataService_idprintlockout } from "./idprintlockout/shared/data.service";
import { PhotoTransferDialogComponent } from "./photomaint/photo-transfer-dialog/photo-transfer-dialog.component";
import { ExportMapFileDialogComponent } from "./photoexport/export-map-file-dialog/export-map-file-dialog.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ColorPickerModule } from 'ngx-color-picker';

@NgModule({
	declarations: [
		IDAdminComponent,
		IDDesignComponent,
		BatchUploadComponent,
		PhotoMaintComponent,
		PhotoEditComponent,
		ImageMaintComponent,
		ImageEditComponent,
		ImageAssociationComponent,
		ImageCopyComponent,
		ImageRenameComponent,
		ImageSetDistrictComponent,
		IDPrintComponent,
		SetPrinterComponent,
		SetCardComponent,
		SetFeeComponent,
		PrintComponent,
		PrinterMaintComponent,
		PhotoExportComponent,
		ClickOnceDeployComponent,
		IDPrintLockoutComponent,
		PhotoTransferDialogComponent,
		ExportMapFileDialogComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		ImageCropperModule,
		SchoolselectorModule,
		DragDropModule,
		ColorPickerModule
	],
	providers: [
		ConfirmationService,
		DataService_iddesign,
		DataService_imagemaint,
		DataService_batchupload,
		DataService_photomaint,
		DataService_idprint,
		DataService_printermaint,
		DataService_photoexport,
		DataService_clickoncedeploy,
		DataService_idprintlockout,
	],
})
export class IDAdminModule {}
